import { render, staticRenderFns } from "./IseqCard.vue?vue&type=template&id=329d3c83&scoped=true"
import script from "./IseqCard.vue?vue&type=script&lang=js"
export * from "./IseqCard.vue?vue&type=script&lang=js"
import style0 from "./IseqCard.vue?vue&type=style&index=0&id=329d3c83&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "329d3c83",
  null
  
)

export default component.exports